import type { SearchResponseData } from '@kimuno/api-sdk/lib/types/responses/Common';
import type { MindItemSearchResult } from '@kimuno/api-sdk/lib/types/responses/MindItem';

import type { AsyncAction } from './common.actionTypes';

export enum FETCH_DASHBOARD_WORKSHEETS {
	START = 'FETCH_DASHBOARD_WORKSHEETS_START',
	SUCCESS = 'FETCH_DASHBOARD_WORKSHEETS_SUCCESS',
	ERROR = 'FETCH_DASHBOARD_WORKSHEETS_ERROR',
}

export type FetchDashboardWorksheetsAction = AsyncAction<
	typeof FETCH_DASHBOARD_WORKSHEETS.START,
	typeof FETCH_DASHBOARD_WORKSHEETS.SUCCESS,
	typeof FETCH_DASHBOARD_WORKSHEETS.ERROR,
	SearchResponseData<MindItemSearchResult>,
	{ subjects: string[] }
>;
